const firebaseConfig = {
    apiKey: "AIzaSyDUCYARv8SYjQp3yfGJ_uonttpShdk-ePQ",
    authDomain: "real-life-superheros.firebaseapp.com",
    projectId: "real-life-superheros",
    storageBucket: "real-life-superheros.appspot.com",
    messagingSenderId: "859074963670",
    appId: "1:859074963670:web:eaa19401aad4576959c177"
  };

  export default firebaseConfig;